"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Advocate() {
  const headline = "READY TO SAVE THOUSANDS ON YOUR NEXT PURCHASE?";
  const words = headline.split(" ");
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: supportRef,
    isVisible: supportVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="4416" id="ready-to-save-thousands" className="relative overflow-hidden bg-white dark">
      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-slate-200" aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute -top-24 -left-24 w-[28rem] h-[28rem] rounded-lg opacity-20 bg-blue-100" style={{
      filter: "blur(80px)"
    }} aria-hidden="true" />
      <div className="pointer-events-none absolute -bottom-32 -right-24 w-[32rem] h-[32rem] rounded-lg opacity-20 bg-orange-100" style={{
      filter: "blur(90px)"
    }} aria-hidden="true" />

      <div className="relative z-10 mx-auto max-w-5xl px-6 py-32 md:py-48 lg:py-60 text-center">
        {}
        <div ref={eyebrowRef} className={`transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs md:text-sm tracking-[0.35em] uppercase font-bold text-orange-600">
            Expert Negotiation
          </span>
        </div>

        {}
        <h2 ref={headlineRef} className="font-default font-bold mt-8 md:mt-10 text-blue-900 leading-[1.05] tracking-tighter uppercase" style={{
        fontSize: "clamp(2.5rem, 6vw, 5rem)"
      }}>
          {words.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-baseline mr-[0.25em]">
              <span className="inline-block transition-all ease-out" style={{
            transitionDuration: "900ms",
            transitionDelay: `${i * 90}ms`,
            transform: headlineVisible ? "translateY(0)" : "translateY(110%)",
            opacity: headlineVisible ? 1 : 0
          }}>
                {word}
              </span>
            </span>)}
        </h2>

        {}
        <p ref={supportRef} className={`font-default mt-10 md:mt-12 mx-auto max-w-2xl text-lg md:text-xl leading-relaxed transition-all duration-700 delay-500 ease-out ${supportVisible ? "opacity-80 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        color: "#333333"
      }}>
          Stop overpaying for your biggest life investments. Our professional advocates use proven strategies to secure the best possible price for you.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 transition-all ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDuration: "900ms",
        transitionDelay: "900ms"
      }}>
          <Button asChild size="lg" className="rounded-lg px-10 py-6 h-auto text-base font-bold tracking-wide shadow-md hover:shadow-lg transition-all bg-orange-600 text-white hover:bg-orange-700">
            <Link to="/PricingPage">View Our Pricing</Link>
          </Button>

          <Link to="/AboutContactPage" className="group inline-flex items-center gap-2 text-blue-900 font-default text-lg font-semibold hover:opacity-70 transition-opacity">
            <span>Contact an Advocate</span>
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>;
}